import { render, staticRenderFns } from "./AddCoursePricing.vue?vue&type=template&id=0d2c9c50&scoped=true"
import script from "./AddCoursePricing.vue?vue&type=script&lang=js"
export * from "./AddCoursePricing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2c9c50",
  null
  
)

export default component.exports